import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=d6cc3e80&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports